import { Component } from '@angular/core';
import { ProfilePicBaseComponent } from '@flipto/shared/src/lib/components/images/profile-pic/profile-pic.base';
import { BackgroundImageDirective } from '@flipto/shared/src/lib/directives/image/background-image.directive';

@Component({
    selector: 'ft-profile-pic',
    templateUrl: './profile-pic.component.html',
    styleUrls: ['./profile-pic.component.scss'],
    standalone: true,
    imports: [BackgroundImageDirective]
})
export class ProfilePicComponent extends ProfilePicBaseComponent {
}
